import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { PersonalNoteCollection } from '../index'

export const setupPersonalNoteReplication = (
  collection: PersonalNoteCollection,
  envId: string,
  currentUserId: string,
) =>
  createReplication({
    entityName: 'personalnotes',
    apiEntityName: 'personalNotes',
    displayName: 'PersonalNote',
    collection,
    envId,
    documentFilter: (doc) => doc?.userId === currentUserId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      userId: doc.userId,
      noteType: doc.noteType,
      noteDate: doc.noteDate,
      title: doc.title,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      userId: state.userId,
      noteType: state.noteType,
      noteDate: state.noteDate,
      title: state.title,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
